import { getAppSetting } from '@/domains/core/settings/appSettings';
import { CURRENCY, PLATFORM } from '@/domains/core/settings/constants';

const PAYPAL_LOCALE = {
  fr: 'fr_FR',
  it: 'it_IT',
  de: 'de_DE',
  gb: 'en_GB',
  es: 'es_ES',
};

export const PAYPAL_OPTIONS = {
  currency: CURRENCY,
  'client-id': getAppSetting('PAYPAL_CLIENT_ID'),
  intent: 'capture',
  'data-client-token': 'abc123xyz===',
  components: 'messages',
  locale: PAYPAL_LOCALE[PLATFORM],
};
